import { FormatStyleName } from 'javascript-time-ago';

import { getTimeAgo } from '../getTimeAgo';

export const formatDate = (date: Date, formatStyle?: FormatStyleName) => {
    const timeAgo = getTimeAgo();

    return timeAgo.format(new Date(date), formatStyle ?? 'round');
};
